import { compose, lazy, mount, redirect, withView } from "navi";
import React from "react";
import { NotFoundBoundary, View } from "react-navi";

import AppLayout from "../layouts/app";
import AuthenticatedLayout from "../layouts/authenticated";
import RefreshTokenLayout from "../layouts/refresh-token";

const authenticatedRoutes = {
  "/": redirect("/projects"),
  "/projects": lazy(() => import("./authenticated/projects")),
  "/create-project": lazy(() => import("./authenticated/create-project")),
  "/terms-of-service": lazy(() => import("./authenticated/terms-of-service")),
  "/investor-profile": lazy(() => import("./authenticated/investor-profile")),
  "/admin": lazy(() => import("./authenticated/admin")),
  "/marketplace": lazy(() => import("./authenticated/marketplace")),
  "/invitation/:projectSlug/:publicInvestmentRoundId": redirect((req) => {
    const p = new URLSearchParams();
    Object.entries(req.params).forEach(([k, v]) => p.set(k, v));

    return `/investments/invitations?${p.toString()}`;
  }),
  // ESOP invitation route - handles esopGrantPublicId param
  "/invitation": redirect((req) => {
    const searchParams = new URLSearchParams(req.url.search);
    const esopGrantPublicId = searchParams.get("esopGrantPublicId");
    const projectSlug = searchParams.get("projectSlug");

    if (esopGrantPublicId) {
      // Redirect to investments invitations with ESOP params
      return `/investments/invitations?projectSlug=${
        projectSlug || ""
      }&esopGrantPublicId=${esopGrantPublicId}`;
    }
    // Fallback to investments
    return "/investments/invitations";
  }),
  "/investments": lazy(() => import("./authenticated/investments")),
  "/settings": lazy(() => import("./authenticated/settings")),
};

const unathenticatedRoutes = {
  "/login": lazy(() => import("./unauthenticated/login")),
  "/link-account": lazy(() => import("./unauthenticated/link-account")),
  "/register": lazy(() => import("./unauthenticated/register")),
  "/reset-password": lazy(() => import("./unauthenticated/reset-password")),
  "/verification": lazy(() => import("./unauthenticated/verification")),
};

const routes = mount({
  ...unathenticatedRoutes,
  "*": compose(
    withView(() => (
      <NotFoundBoundary render={() => <h1>Not Found</h1>}>
        <View />
      </NotFoundBoundary>
    )),
    withView(() => (
      <AuthenticatedLayout>
        <View />
      </AuthenticatedLayout>
    )),
    withView(() => (
      <RefreshTokenLayout>
        <View />
      </RefreshTokenLayout>
    )),
    withView(() => (
      <AppLayout>
        <View />
      </AppLayout>
    )),
    mount(authenticatedRoutes)
  ),
});

export default routes;
